<template>
    <div class="MultipleChoiceInputGrid" :class="{ done }">
        <div class="items">
            <div
                v-for="(item, i) of items"
                :key="i"
                class="Item --global-clickable"
                :class="{ selected: selections.indexOf(i) !== -1 }"
                :style="style"
                @click="$emit('item-click', i)"
            >
                <span class="Item__content">{{ item }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { TimelineMax, Power2 } from 'gsap';
import soundService from '@/services/sound-service';
import correctSound from '@/assets/sounds/correct-answer.mp3';

export default {
    props: ['items', 'selections'],
    inject: ['theme'],
    data() {
        return {
            done: false
        };
    },
    computed: {
        style() {
            return {
                backgroundColor: this.theme.primaryActiveColor,
                color: this.theme.textColorOnPrimaryColor
                // borderColor: this.theme.primaryActiveColor
                // primaryActiveColor
            };
        }
    },
    beforeDestroy() {
        if (this.tl) {
            this.tl.kill();
        }
    },
    methods: {
        playFeedbackWrong() {
            this.done = true;
            return new Promise(resolve => {
                let shakeSpeed = 0.1;
                let elementsToShake = Array.from(this.$el.querySelectorAll('.Item.selected'));

                let tl = (this.tl = new TimelineMax({ onComplete: () => resolve() }));
                tl.to(elementsToShake, shakeSpeed, {
                    x: -7,
                    ease: Power2.easeInOut
                });
                tl.to(elementsToShake, shakeSpeed, {
                    repeat: 4,
                    x: 5,
                    yoyo: true,
                    ease: Power2.easeInOut
                });
                tl.to(elementsToShake, shakeSpeed, {
                    x: 0
                });
            });
        },
        playFeedbackCorrect() {
            this.done = true;
            soundService.play(correctSound);

            return new Promise(resolve => {
                let elementsToAnimate = this.$el.querySelectorAll('.Item.selected');
                let tl = (this.tl = new TimelineMax({ onComplete: () => resolve() }));
                tl.to(elementsToAnimate, 0.3, {
                    scale: 1.05,
                    ease: Power2.easeInOut
                });
                tl.to(elementsToAnimate, 0.3, {
                    scale: 1,
                    ease: Power2.easeInOut
                });
            });
        }
    }
};
</script>

<style scoped lang="scss">
.MultipleChoiceInputGrid {
    // padding: 1em;
    &.done {
        .Item:not(.selected) {
            transition: opacity 0.5s;
            opacity: 0;
        }
    }
}

.items {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.Item {
    padding: 1em 1.5em;
    margin: 0.4em;
    border-radius: 0.3em;
    // border: 3px solid transparent; //rgba(white, 0.1);
    text-transform: lowercase;

    &.selected {
        // background-color: white;
        // color: black;
        border-color: rgb(213, 120, 222);
        // background-color: rgb(213, 120, 222);
        color: white;
    }
    &:not(.selected) {
        color: black !important;
        background-color: white !important; //#301b82;
        // background-color: transparent !important;
    }
}
.Item__content {
    font-size: 120%;
}
</style>
